export default "__VITE_ASSET__BAf0GWsG__"